import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { api, apiErr, API } from "../../lib/api";
import { toast } from "sonner";
import { FileText, ExternalLink, Info, Check } from "lucide-react";

export default function ContratTab() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/contrat/contenu").then((r) => setContent(r.data)).catch((e) => toast.error(apiErr(e)));
  }, []);

  return (
    <div data-testid="contrat-tab">
      <div className="rounded-2xl bg-brand-50/60 border border-brand/15 p-5 mb-6 text-sm text-ink-600 flex items-start gap-3">
        <Info size={20} className="text-brand shrink-0 mt-0.5" />
        <span>Voici le contrat de location envoyé aux clients. <strong>Relisez-le</strong> et indiquez-moi les modifications souhaitées (par numéro d'article, ex. « Article 6 : mettre la caution à 700 € »). Chaque contrat est automatiquement pré-rempli avec les informations de la réservation.</span>
      </div>

      <div className="flex flex-wrap gap-2 mb-6">
        <a href={`${API}/contrat-exemple.pdf`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-brand text-white px-5 py-2.5 text-sm font-medium hover:bg-brand-600" data-testid="contrat-open-pdf">
          <ExternalLink size={16} /> Ouvrir un exemple (PDF)
        </a>
      </div>

      {content && (
        <>
          <h3 className="font-heading text-xl text-ink-900 mb-3">Points clés</h3>
          <div className="grid sm:grid-cols-2 gap-2 mb-8">
            {content.key_terms.map((k, i) => (
              <div key={k} className="flex items-start gap-2 text-sm text-ink-700 bg-white border border-black/5 rounded-xl p-3">
                <Check size={15} className="text-brand mt-0.5 shrink-0" /> {k}
              </div>
            ))}
          </div>

          <h3 className="font-heading text-xl text-ink-900 mb-3">Conditions générales</h3>
          <div className="space-y-4">
            {content.articles.map((a, i) => (
              <div key={a.title} className="rounded-2xl bg-white border border-black/5 p-4" data-testid={`contrat-article-${i + 1}`}>
                <p className="font-semibold text-brand mb-1.5">{a.title}</p>
                <p className="text-sm text-ink-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(a.body) }} />
              </div>
            ))}
          </div>

          <div className="mt-6 rounded-2xl bg-cream border border-black/5 p-4">
            <p className="text-sm text-ink-600 flex items-center gap-2"><FileText size={16} className="text-brand" /> Aperçu du document complet (mise en page finale) :</p>
            <iframe title="Contrat exemple" src={`${API}/contrat-exemple.pdf`} className="w-full h-[600px] mt-3 rounded-xl border border-black/10" />
          </div>
        </>
      )}
    </div>
  );
}
